export type ShapeMatrix = number[][];

export interface PieceData {
  shape: ShapeMatrix;
  colorIndex: number;
  rows: number;
  cols: number;
}

export enum PieceType {
  SQUARE = 'SQUARE',
  I = 'I',
  L = 'L',
  T = 'T',
  S = 'S',
  Z = 'Z',
  SMALL = 'SMALL',
}

// All piece shapes as 0/1 matrices
const SHAPES: Record<PieceType, ShapeMatrix> = {
  [PieceType.SQUARE]: [
    [1, 1],
    [1, 1],
  ],
  [PieceType.I]: [
    [1, 1, 1, 1],
  ],
  [PieceType.L]: [
    [1, 0],
    [1, 0],
    [1, 1],
  ],
  [PieceType.T]: [
    [1, 1, 1],
    [0, 1, 0],
  ],
  [PieceType.S]: [
    [0, 1, 1],
    [1, 1, 0],
  ],
  [PieceType.Z]: [
    [1, 1, 0],
    [0, 1, 1],
  ],
  [PieceType.SMALL]: [
    [1],
  ],
};

export const PIECE_TYPES: PieceType[] = [
  PieceType.SQUARE,
  PieceType.I,
  PieceType.L,
  PieceType.T,
  PieceType.S,
  PieceType.Z,
  PieceType.SMALL,
];

/**
 * Rotate a shape matrix 90° clockwise.
 */
export function rotateShape(matrix: ShapeMatrix): ShapeMatrix {
  const rows = matrix.length;
  const cols = matrix[0].length;
  const result: ShapeMatrix = [];
  for (let c = 0; c < cols; c++) {
    const newRow: number[] = [];
    for (let r = rows - 1; r >= 0; r--) {
      newRow.push(matrix[r][c]);
    }
    result.push(newRow);
  }
  return result;
}

/**
 * Get the shape matrix for a piece type.
 */
export function getShape(type: PieceType): ShapeMatrix {
  // Return a deep copy
  return SHAPES[type].map((row) => [...row]);
}

/**
 * Get all shapes as a list of arrays.
 */
export function getAllShapes(): PieceType[] {
  return PIECE_TYPES;
}